export default __webpack_public_path__ + "static/media/JuniousRedDance.1cc10448.gif";